import { Toaster } from 'sonner'
import { TOAST_DURATION_MS } from './toasts'
import { selectIsFooterActionBarOpen, useUiStore } from '@/store/ui'

/**
 * Clears the `document-flow-layout.tsx` footer action bar (~66px plus room).
 * Applied only while that bar is on screen — everywhere else sonner's own
 * 24px/16px viewport padding is the right distance (#1666).
 */
const TOAST_LIFTED_OFFSET = '96px'

/**
 * The app's one `<Toaster/>`. The lift is scoped to the screens that register a
 * footer action bar (#1516 anomaly 10): sonner writes `--offset-*` inline
 * on every render, so a stylesheet cannot override it without `!important`, and
 * this component sits above `RouterProvider` so it cannot read the route.
 */
export const AppToaster = () => {
  const isLifted = useUiStore(selectIsFooterActionBarOpen)
  const offset = isLifted ? { bottom: TOAST_LIFTED_OFFSET } : undefined

  return (
    <Toaster
      duration={TOAST_DURATION_MS}
      offset={offset}
      mobileOffset={offset}
    />
  )
}
